<template lang="pug">
.entity-tab.py-0.fluid
  v-row
    v-col(cols="4")
      v-text-field(
        :value="instance['label']",
        @input="$store.commit(setInstancePathAction, { path: path + '.label', value: $event })",
        :label="$t('DataSet.label')",
      )
  v-row
    v-col()
      app-entity-relation(
        :relation="criteriasRelation"
        :entity="$findEntity('Criteria')",
        :parent="$findEntity('DataSet')",
        :parentInstance="instance",
        :parentPath="`${path}`",
        :path="`${path}.criterias`",
      )

</template>

<script>
import EntityMixin from "@/mixins";

export default {
  mixins: [EntityMixin],
  props: {
    replasable: {
      type: Boolean,
      default: true,
    },
    chips: {
      type: Boolean,
      default: true,
    },
    invert: {
      type: Boolean,
      default: true,
    },
    selector: {
      type: Boolean,
      default: true,
    },
    selectorOnly: {
      type: Boolean,
      default: false,
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
    path: {
      type: String,
      default: null
    },
    parentPath: {
      type: String,
      default: null
    },
    fromList: Boolean,
    parent: {
      type: Object,
      default: () => ({})
    },
    parentInstance: {
      type: Object,
      default: () => ({})
    },
    isActive: {
      type: Boolean,
      default: false
    },
    relation: null,
    elementIndex: null,
  },
  data: function () {
    return {

    };
  },
  computed: {
    criteriasRelation() {
      let foundRelations = this.entity.fields.filter((r) => r.name == "criterias");
      return foundRelations.length === 1 ? foundRelations[0] : {};
    },
  },
  methods: {
    async load() {
      if (this.instance.uid) {
        try {
          this.instance.entityState = 3;
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },
  },
  async created() {
    await this.load();
  },
};
</script>
